export const langs = [
    { id: "ua", name: "Українська" },
  { id: "en", name: "English" },
];
